import { Collection } from '../collection';
import { CollectionAction } from '../collection-action.interface';
import { CollectionAsset } from '../collection-asset';
import { CollectionState } from '../collection-state.interface';

const findExistingAsset = (
  existingCollection: Collection,
  asset: CollectionAsset,
) => {
  const existingAsset = existingCollection.assets
    && existingCollection.assets.find(
      (collectionAsset) => collectionAsset.sourceAssetId === asset.sourceAssetId
        && collectionAsset.assetType === asset.assetType,
    );

  if (existingAsset) {
    Object.assign(existingAsset, asset);

    return existingAsset;
  }

  return null;
};

const updateCollection = (
  updatedCollection: Collection,
  existingCollection: Collection,
): Collection => {
  const updatedCollectionAssets = updatedCollection.assets.map((asset) => {
    const existingAsset = findExistingAsset(existingCollection, asset);

    return existingAsset || asset;
  });

  return {
    ...existingCollection,
    ...updatedCollection,
    assets: updatedCollectionAssets,
    count: updatedCollectionAssets.length,
    name: updatedCollection.name,
  };
};

const onUpdateSuccess = (
  state: CollectionState,
  action: CollectionAction,
): CollectionState => {
  const updatedCollection: Collection = action.collection as Collection;

  return {
    ...state,
    listOfCollections: state.listOfCollections.map((existingCollection) => {
      if (
        existingCollection.collectionId === updatedCollection.collectionId
      ) {
        return updateCollection(updatedCollection, existingCollection);
      }

      return existingCollection;
    }),
    isUpdating: false,
  };
};

export default onUpdateSuccess;
